import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';

export const AddTeamToRepoDetails = ({ ticket }) => (
  <SectionCard title="Request Information">
    <TextDataField
      name="Team name"
      value={ticket && ticket.ticket_data.team_name} />
    <TextDataField
      name="Repo name"
      value={ticket && ticket.ticket_data.repo_name} />
  </SectionCard>
);

AddTeamToRepoDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
AddTeamToRepoDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
